import jsPDF from 'jspdf';
import 'jspdf-autotable';
import config from "../common/Config";
import axios from 'axios';

const generateUniqueFilename = (baseName, extension) => {
  const timestamp = new Date().toISOString().replace(/[-:.]/g, "");
  return `${baseName}_${timestamp}.${extension}`;
};

const generateSummaryPDF = async (printCount = 1) => {
  const accessToken = localStorage.getItem('accessToken');
  const company_tax_type = localStorage.getItem("company_tax_type");
  const invoiceIds = JSON.parse(sessionStorage.getItem('invoiceIds'));
  console.log(invoiceIds);
  const formData = new FormData();
  formData.set('invoiceIds', invoiceIds);
  const apiUrl = `${config.API_URL}/ws-multiple-proforma-invoice`;

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  try {
    const response = await axios.post(apiUrl, formData, {
      headers: {
        authorization: `Bearer ${accessToken}`,
      },
    });

    const data = response.data;
    console.log(data);

    if (!data.success || !data.details.invoices || data.details.invoices.length === 0) {
      console.error("No invoices found in the response.");
      return;
    }

    const shopDetails = data.details.shop_details;
    const allInvoices = data.details.invoices;
    const customerLedger = data.details.customer_ledger;
    console.log('All invoices:', allInvoices);

    const addRibbonTitle = (doc, title, fontSize, pageWidth, margin, topMargin) => {
      // Set font and size for the title
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(fontSize);
    
      // Set text color
      doc.setTextColor(0, 0, 0); // Set text color to black (RGB: 0, 0, 0)
    
      // Calculate the position for the text
      const titleWidth = doc.getTextWidth(title);
      const titleX = pageWidth - titleWidth - margin; // Align text to the right
      const titleY = topMargin + fontSize; // Add top margin to the Y position
    
      // Add the title text
      doc.text(title, titleX, titleY);
    };

    const doc = new jsPDF('portrait');
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const margin = 10;
    let y = margin;
    const firstColumnWidth = pageWidth * 0.25;
    const secondColumnWidth = pageWidth * 0.75;

    const H2firstColumnWidth = pageWidth * 0.40;
    const H2secondColumnWidth = pageWidth * 0.25;
    const H2thirdColumnWidth = pageWidth * 0.25;

    const logoUrl = `${config.BASE_URL}/assets/img/${accessToken}_logo.png`;
    const logoWidth = 40;
    const logoHeight = 15;

    // Repeat each invoice printCount times
    allInvoices.forEach((invoice, invoiceIndex) => {
      for (let repeat = 0; repeat < printCount; repeat++) {
        if (invoiceIndex > 0 || repeat > 0) {
          doc.addPage();
          y = margin;
        }

        const orderDetails = invoice.orderDetails;
        const orderProducts = invoice.product_details || [];
        const deliveryDetails = invoice.delivery_details || [];
        const invoiceType = invoice.invoice_type || 'Invoice';

        doc.addImage(logoUrl, 'PNG', margin, y, logoWidth, logoHeight);
        y += logoHeight + 5;

        // Add ribbon title
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(10);
        const title = `${invoiceType}`;
        const fontSize = 10;
        const topMargin = 3;
        addRibbonTitle(doc, title, fontSize, pageWidth, margin, topMargin);
        y += 10;

        // WITHOUT CONTRACT PRODUCTS
        const totalstd_without_contract = orderProducts
          .filter(item => 
            item.item_tax !== '0.00' && 
            item.item_tax != null && 
            item.isContractPriceApplied === 'N'
          )
          .reduce((sum, item) => sum + parseFloat(item.subtotal || 0), 0);

        const totalzeroGoods_without_contract = orderProducts
          .filter(item => 
            (item.item_tax === '0.00' || item.item_tax === null || item.item_tax === '') && 
            item.isContractPriceApplied === 'N'
          )
          .reduce((sum, item) => sum + parseFloat(item.subtotal || 0), 0);

        const totalTax_without_contract = orderProducts
          .filter(item => 
            item.item_tax !== '0.00' && 
            item.item_tax != null && 
            item.item_tax !== '' &&
            item.isContractPriceApplied === 'N'
          )
          .reduce((sum, item) => sum + (parseFloat(item.item_tax) || 0), 0);

        // WITH CONTRACT PRODUCTS
        const totalstd_with_contract = orderProducts
          .filter(item => 
            item.item_tax !== '0.00' && 
            item.item_tax != null && 
            item.isContractPriceApplied === 'Y'
          )
          .reduce((sum, item) => sum + parseFloat(item.subtotal || 0), 0);

        const totalzeroGoods_with_contract = orderProducts
          .filter(item => 
            (item.item_tax === '0.00' || item.item_tax === null || item.item_tax === '') && 
            item.isContractPriceApplied === 'Y'
          )
          .reduce((sum, item) => sum + parseFloat(item.subtotal || 0), 0);

        const totalTax_with_contract = orderProducts
          .filter(item => 
            item.item_tax !== '0.00' && 
            item.item_tax != null && 
            item.item_tax !== '' &&
            item.isContractPriceApplied === 'Y'
          )
          .reduce((sum, item) => sum + (parseFloat(item.item_tax) || 0), 0);

        // COMBINE TOTALS
        const totalstd = totalstd_without_contract + totalstd_with_contract;
        const totalzeroGoods = totalzeroGoods_without_contract + totalzeroGoods_with_contract;

        const box_qty = orderProducts
          .filter(item => item.quantity != '0.00' && item.quantity != null && item.order_type === 'box')
          .reduce((sum, item) => sum + (parseFloat(item.quantity) || 0), 0);

        const piece_qty = orderProducts
          .filter(item => item.quantity != '0.00' && item.quantity != null && item.order_type === 'piece')
          .reduce((sum, item) => sum + (parseFloat(item.quantity) || 0), 0);

        // DISCOUNT CALCULATIONS
        const totalSTDGoods = parseFloat(totalstd) || 0;
        const orderDiscount = parseFloat(orderDetails.order_discount) || 0;
        const orderDiscount1 = parseFloat(orderDetails.order_discount) || 0;
        const orderDiscount2 = parseFloat(orderDetails.over_all_discount) || 0;

        // APPLY OVERALL DISCOUNT ONLY TO NON-CONTRACT PRODUCTS
        const totalWithoutContract = totalstd_without_contract + totalzeroGoods_without_contract;
        let orderDiscount3 = (totalWithoutContract * (parseFloat(orderDetails.over_all_discount) || 0)) / 100 || 0;

        // CALCULATE DISCOUNT PERCENTAGE (only applies to non-contract items)
        let totalDiscountOnVat = 0;
        if(parseFloat(orderDetails.over_all_discount) > 0) {
          totalDiscountOnVat += parseFloat(orderDetails.over_all_discount);
        }

        if(orderDetails.percentage !== null && orderDetails.percentage !== undefined) {
          totalDiscountOnVat += parseFloat(orderDetails.percentage) || 0;
        }

        // APPLY VAT DISCOUNT ONLY TO NON-CONTRACT VAT
        const discountedVatWithoutContract = totalTax_without_contract - 
          (totalTax_without_contract * totalDiscountOnVat) / 100;

        // TOTAL VAT = discounted non-contract VAT + full contract VAT
        let totalVAT = discountedVatWithoutContract + totalTax_with_contract;

        // ITEM TOTAL
        const itemTotal = totalstd + totalzeroGoods;

        // OVERALL AMOUNT (only applies to non-contract products)
        let over_all_amount = (totalWithoutContract * (parseFloat(orderDetails.over_all_discount) || 0)) / 100;

        // TOTAL AMOUNT - Always use the formula for consistency
        let totalAmount = totalstd + totalzeroGoods + totalVAT - (parseFloat(orderDetails.order_discount) || 0) - over_all_amount;

        // Debug logging
        console.log('Invoice calculations:', {
          invoiceId: orderDetails.reference_no,
          totalstd,
          totalzeroGoods,
          totalVAT,
          orderDiscount: orderDetails.order_discount,
          over_all_amount,
          totalAmount,
          grand_total: invoice.grand_total
        });

        const boldTxt = '<b>';
        const boldTxtClose = '</b>';
        const headerSections2 = [
          [
          ],
          [
            { text: `${shopDetails.shop_name}`, size: 13, bold: true },
            { text: `${shopDetails.address.split(',')[0]}`, size: 8, bold: false },
            { text: `${shopDetails.address.split(',')[1]}`, size: 8, bold: false },
            { text: `Company No : ${shopDetails.company_reg_no} | ${company_tax_type} No : ${shopDetails.vat_no}`, size: 8, bold: false },
            { text: `Phone No : ${shopDetails.phone} | Email : ${shopDetails.email}`, size: 8, bold: false },
            { text: `Website : ${shopDetails.website} | AWRS No : ${shopDetails.awrs_no}`, size: 8, bold: false },
          ],
        ];

        const headerSections3 = [
          [
            { text: `Customer Details`, size: 8, bold: true },
            { text: `${orderDetails.company || orderDetails.name}`, size: 8, bold: true },
            { text: `${orderDetails.address}`, size: 8, bold: false },
            { text: `${orderDetails.postal_code}`, size: 8, bold: false },
            { text: `Phone No : ${orderDetails.phone} | Email : ${orderDetails.email}`, size: 8, bold: false },
          ],
          [
            { text: `Invoice No : ${orderDetails.reference_no}`, size: 8, bold: false },
            { text: `Invoice Date: ${orderDetails.date || orderDetails.invoice_date}`, size: 8, bold: false },
            { text: `A/C No: ${orderDetails.accound_no || orderDetails.account_no}`, size: 8, bold: false },
            { text: `Route No : ${orderDetails.route_number}`, size: 8, bold: false },
            { text: `Order By: ${orderDetails.orderby}`, size: 8, bold: false },
          ],
          [
            { text: `Bank Details`, size: 8, bold: true },
            { text: `${shopDetails.shop_name}`, size: 8, bold: true },
            { text: ``, size: 8, bold: false },
            { text: `A/C No : ${shopDetails.bank_ac}`, size: 8, bold: false },
            { text: `Sort Code: ${shopDetails.sort_code}`, size: 8, bold: false },
          ],
        ];

        const sectionWidth = (pageWidth - margin * 2) / 2;

        y = 7;
        const renderSections = (sections, marginTop = 7) => {
          let yPosition = y + marginTop;

          sections.forEach((section, index) => {
            const colStartX = margin + (index % 3) * firstColumnWidth;

            section.forEach((item, i) => {
              doc.setFontSize(item.size);
              doc.setFont(item.bold ? 'helvetica' : 'helvetica', item.bold ? 'bold' : 'normal');
              doc.text(item.text, colStartX, yPosition + i * 4);
            });

            if (index % 4 === 3) {
              yPosition += 12;
            }
          });

          yPosition += 25;
          y = yPosition;
        };
        renderSections(headerSections2);

        const h2renderSections = (sections) => {
          let rowHeight = 0;
          let rowStartY = y;
          let columnHeights = [];

          sections.forEach((section, index) => {
            let colStartX;
            if (index % 3 === 0) {
              colStartX = margin;
            } else if (index % 3 === 1) {
              colStartX = margin + H2firstColumnWidth;
            } else {
              colStartX = margin + H2firstColumnWidth + H2secondColumnWidth;
            }

            let sectionHeight = 0;

            section.forEach((item, i) => {
              doc.setFontSize(item.size);
              doc.setFont(item.bold ? 'helvetica' : 'helvetica', item.bold ? 'bold' : 'normal');

              let maxWidth;
              if (index % 3 === 0) {
                maxWidth = H2firstColumnWidth - 5;
              } else if (index % 3 === 1) {
                maxWidth = H2secondColumnWidth - 5;
              } else {
                maxWidth = H2thirdColumnWidth - 5;
              }

              const textWidth = doc.getTextWidth(item.text);
              let lines = [];
              if (textWidth > maxWidth) {
                let words = item.text.split(' ');
                let line = '';

                words.forEach((word) => {
                  const testLine = line + (line ? ' ' : '') + word;
                  if (doc.getTextWidth(testLine) <= maxWidth) {
                    line = testLine;
                  } else {
                    lines.push(line);
                    line = word;
                  }
                });
                lines.push(line);
              } else {
                lines.push(item.text);
              }

              lines.forEach((lineText, lineIndex) => {
                const lineHeight = 4;
                doc.text(lineText, colStartX + 5, y + 5 + i * lineHeight + lineIndex * lineHeight);
                sectionHeight = y + i + lineIndex - 5;
              });
            });

            columnHeights.push(sectionHeight);

            if ((index + 1) % 3 === 0) {
              rowHeight = Math.max(...columnHeights);
              columnHeights = [];

              let colX = margin;
              for (let i = 0; i < 3; i++) {
                doc.setLineWidth(0.1);
                let colWidth = (i === 0) ? H2firstColumnWidth : (i === 1) ? H2secondColumnWidth : H2thirdColumnWidth;
                doc.rect(colX, rowStartY - 2, colWidth, rowHeight + 4);
                colX += colWidth;
              }

              y += rowHeight + 12;
            }
          });

          y += -3;
        };

        h2renderSections(headerSections3);

        const tableColumns = [
          { title: 'Product', dataKey: 'product', size: 8, bold: true, halign: 'center' },
          { title: 'Type', dataKey: 'order_type', size: 8, bold: true, halign: 'center' },
          { title: 'Qty', dataKey: 'qty', size: 8, bold: true, halign: 'center' },
          { title: 'Price', dataKey: 'unit_price', size: 8, bold: true, halign: 'center' },
          { title: 'Disc', dataKey: 'discount', size: 8, bold: true, halign: 'center' },
          { title: `${company_tax_type}`, dataKey: 'vat', size: 8, bold: true, halign: 'center' },
          { title: 'Total', dataKey: 'net_amount', size: 8, bold: true, halign: 'center' },
        ];

        const totalWidth = pageWidth - 2 * margin;
        const productWidth = totalWidth * 0.45;
        const orderTypeWidth = totalWidth * 0.06;
        const qtyWidth = totalWidth * 0.06;
        const unitPriceWidth = totalWidth * 0.12;
        const discountWidth = totalWidth * 0.08;
        const vatWidth = totalWidth * 0.11;
        const netAmountWidth = totalWidth * 0.12;

        const tableBody = orderProducts.map((item) => [
          item.product_code + ' - ' + item.product_name + ' - ' + (item.size || '') + (item.promo_product || '') + (item.free_product || '') + (item.ContractPrice || ''),
          item.order_type || '',
          parseInt(item.quantity) || 0,
          '£' + (parseFloat(item.unit_price) || 0).toFixed(2),
          item.item_discount,
          '£' + (parseFloat(item.item_tax) || 0).toFixed(2),
          '£' + (parseFloat(item.subtotal) || 0).toFixed(2),
        ]);

        tableBody.push([
          { content: 'Item Total:', colSpan: 6, styles: { halign: 'right' } },
          { content: `£ ${(itemTotal || 0).toFixed(2)}` }
        ]);

        tableBody.push([
          { content: `Total Zero VAT Goods - £ ${(totalzeroGoods || 0).toFixed(2)}  | Total VAT Goods - £ ${(totalstd || 0).toFixed(2)}`, colSpan: 5, styles: { halign: 'left' } },
          { content: `${company_tax_type} Amount:`, styles: { halign: 'right', fontSize: 8, fontStyle: 'bold' } },
          { content: `£ ${(totalVAT || 0).toFixed(2)}` }
        ]);

        if (orderDiscount2 != 0 && orderDiscount2 !== '') {
          tableBody.push([
            { content: `Order Discount (${orderDiscount2}%):`, colSpan: 6, styles: { halign: 'right', fontSize: 8, fontStyle: 'bold' } },
            (orderDiscount3 || 0).toFixed(2)
          ]);
        }

        if (orderDiscount1 != 0 && orderDiscount1 !== '') {
          tableBody.push([
            { content: `Promo Discount :`, colSpan: 6, styles: { halign: 'right', fontSize: 8, fontStyle: 'bold' } },
            (orderDiscount || 0).toFixed(2)
          ]);
        }

        tableBody.push([
          { content: `Box : ${box_qty || 0} PCs : ${piece_qty || 0} `, colSpan: 5, styles: { halign: 'left' } },
          { content: 'Invoice Total:', styles: { halign: 'right', fontSize: 8, fontStyle: 'bold' } },
          { content: `£ ${(totalAmount || 0).toFixed(2)}` }
        ]);

        doc.autoTable({
          startY: y,
          head: [tableColumns.map(col => col.title)],
          body: tableBody,
          theme: 'grid',
          headStyles: {
            fillColor: '#f8f9fa',
            textColor: '#404040',
            fontSize: 8,
            valign: 'middle',
            lineWidth: 0.3,
            halign: 'center',
            lineWidth: 0.3,
            lineColor: [0, 0, 0]
          },
          bodyStyles: {
            fontSize: 8,
            valign: 'middle',
            lineWidth: 0.3,
            lineColor: [0, 0, 0]
          },
          margin: { top: 0, left: margin, right: margin },
          columnStyles: {
            0: { cellWidth: productWidth, fontSize: 8, fontStyle: 'bold' },
            1: { cellWidth: orderTypeWidth, fontSize: 8, fontStyle: 'bold' },
            2: { cellWidth: qtyWidth, fontSize: 8, fontStyle: 'bold' },
            3: { cellWidth: unitPriceWidth, fontSize: 8, fontStyle: 'bold' },
            4: { cellWidth: discountWidth, fontSize: 8, fontStyle: 'bold' },
            5: { cellWidth: vatWidth, fontSize: 8, fontStyle: 'bold' },
            6: { cellWidth: netAmountWidth, fontSize: 8, fontStyle: 'bold' },
            1: { halign: 'center' },
            2: { halign: 'center' },
            3: { halign: 'right' },
            4: { halign: 'center' },
            5: { halign: 'right' },
            6: { halign: 'right' },
          },
        });

        y = doc.autoTable.previous.finalY + 5;

        const addFooterSection = (footerSection) => {
          footerSection.forEach((section, index) => {
            const colStartX = margin + (index % 4) * sectionWidth;

            section.forEach((item, i) => {
              doc.setFontSize(item.size);
              doc.setFont(item.bold ? 'helvetica' : 'helvetica', item.bold ? 'bold' : 'normal');
              doc.text(item.text, colStartX, y + i * 5);
            });

            if (index % 4 === 3) {
              y += 20;
            }
          });
          y += 25;
        };

        const addFooterWithSpaceCheck = (footerSection) => {
          const remainingSpace = pageHeight - y - margin;
          const requiredSpace = footerSection.length * 5 + 20;

          if (remainingSpace < requiredSpace) {
            doc.addPage();
            y = margin;
          }

          addFooterSection(footerSection);
          y += 10;
        };

        const footerSections2 = [
          [
            { text: 'Delivery Checked & Collected By : _ _ _ _ _ _ _ _ _', size: 8, bold: false },
            { text: 'Amt Paid :_ _ _ _ _ _ _ _ _ _Collected By :_ _ _ _ _ _ _ _ _ _ ', size: 8, bold: false },
            { text: 'Terms -', size: 8, bold: false },
            { text: `1 - Once delivery is received ${shopDetails.shop_name} is not responsible for any damage or loss `, size: 8, bold: false },
            { text: `2 - Goods remain the property of ${shopDetails.shop_name} until invoice fully paid `, size: 8, bold: false },
            { text: `3 - No claims for damages or short delivery will be considered unless made at the time of delivery of goods.`, size: 8, bold: false },
            { text: `4 - There is No Refund Policy Of goods sold`, size: 8, bold: false },
          ]
        ];

        addFooterWithSpaceCheck(footerSections2);

        const footerSections3 = [
          [
            { text: `Staff Note: ${orderDetails.staff_note || ''}`, size: 8, bold: true },
            { text: `Note For Driver: ${orderDetails.note_for_driver || ''}`, size: 8, bold: true },
          ]
        ];

        addFooterWithSpaceCheck(footerSections3);

        // Add delivery details signature box if available
        if (Array.isArray(deliveryDetails) && deliveryDetails.length > 0) {
          const boxMarginTop = 5;
          const boxHeight = 20;
          const boxWidth = pageWidth - 2 * margin;
          let boxY = y + boxMarginTop;

          // Ensure box fits on page, else add new page
          if (boxY + boxHeight > pageHeight - margin) {
            doc.addPage();
            boxY = margin + boxMarginTop;
          }

          // Draw the box
          doc.setLineWidth(0.2);
          doc.rect(margin, boxY, boxWidth, boxHeight);

          // Add the labels inside the box
          doc.setFontSize(10);
          doc.setFont('helvetica', 'bold');
          let collectedByText = 'Goods Collected By:';
          let signatureText = 'Signature:';

          // If deliveryDetails is present, use dynamic values
          const recipient = deliveryDetails[0];
          if (recipient.received_by) {
            collectedByText = `Goods Collected By: ${recipient.received_by}`;
          }

          doc.text(collectedByText, margin + 5, boxY + 15);
          doc.text(signatureText, margin + boxWidth / 2 + 5, boxY + 15);

          // Line for signature
          doc.line(margin + boxWidth / 2 + 25, boxY + 15, margin + boxWidth - 10, boxY + 15);

          // If deliveryDetails has a signature, add it above the signature label
          if (recipient.recipient_signature) {
            const sigWidth = 15;
            const sigHeight = 10;
            const sigAreaStart = margin + boxWidth / 2 + 15;
            const sigAreaEnd = margin + boxWidth - 10;
            const sigX = sigAreaStart + ((sigAreaEnd - sigAreaStart) - sigWidth) / 2;
            const sigY = boxY + 4;
            doc.addImage(recipient.recipient_signature, 'PNG', sigX, sigY, sigWidth, sigHeight);
          }

          y = boxY + boxHeight + 5;
        }

        const remainingSpace = pageHeight - y - 10;

        if (remainingSpace >= 20) {
          // Space available for additional content
        } else {
          // Add new page if needed
        }
      }
    });

    // const addPageNumbers = (doc) => {
    //   const pageCount = doc.internal.getNumberOfPages();
    //   const pageWidth = doc.internal.pageSize.getWidth();
    //   const pageHeight = doc.internal.pageSize.getHeight();

    //   for (let i = 1; i <= pageCount; i++) {
    //     doc.setPage(i);
    //     doc.setFontSize(8);

    //     const pageNumberText = `Page ${i} of ${pageCount}`;
    //     const textWidth = doc.getTextWidth(pageNumberText);
    //     const xPosition = pageWidth - textWidth - 10;

    //     doc.text(pageNumberText, xPosition, pageHeight - 12);
    //   }
    // };

    // addPageNumbers(doc);
    // Add this function to replace your current addPageNumbers function
const addOrderSpecificPageNumbers = (doc, allInvoices, printCount) => {
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  
  let globalPageNumber = 1;
  
  // Calculate pages per invoice (including repeats)
  allInvoices.forEach((invoice, invoiceIndex) => {
    const orderNumber = invoice.orderDetails.reference_no;
    
    // Reset page numbering for each new order
    for (let repeat = 0; repeat < printCount; repeat++) {
      // Set the page for this specific invoice copy
      doc.setPage(globalPageNumber);
      doc.setFontSize(8);
      doc.setFont('helvetica', 'normal');
      
      // Create order-specific page number text - starts from 1 for each order
      let pageNumberText;
      if (printCount > 1) {
        // If multiple copies, show page number restarting from 1 for each order
        pageNumberText = `Order: ${orderNumber} - Page ${repeat + 1} of ${printCount}`;
      } else {
        // If single copy, show page 1 for each order
        pageNumberText = `Order: ${orderNumber} - Page 1`;
      }
      
      // Position the text at bottom right
      const textWidth = doc.getTextWidth(pageNumberText);
      const xPosition = pageWidth - textWidth - 10;
      
      doc.text(pageNumberText, xPosition, pageHeight - 12);
      
      globalPageNumber++;
    }
  });
};

// Alternative version if you want sequential numbering per invoice
const addSequentialOrderPageNumbers = (doc, allInvoices, printCount) => {
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  
  let currentPage = 1;
  
  allInvoices.forEach((invoice, invoiceIndex) => {
    const orderNumber = invoice.orderDetails.reference_no;
    
    for (let repeat = 0; repeat < printCount; repeat++) {
      doc.setPage(currentPage);
      doc.setFontSize(8);
      doc.setFont('helvetica', 'normal');
      
      // Sequential numbering: Order 1 Copy 1, Order 1 Copy 2, Order 2 Copy 1, etc.
      const pageNumberText = `Order ${invoiceIndex + 1} (${orderNumber}) - Page ${repeat + 1}/${printCount}`;
      
      const textWidth = doc.getTextWidth(pageNumberText);
      const xPosition = pageWidth - textWidth - 10;
      
      doc.text(pageNumberText, xPosition, pageHeight - 12);
      
      currentPage++;
    }
  });
};

// Usage in your main function:
// Replace the existing addPageNumbers call with:
addOrderSpecificPageNumbers(doc, allInvoices, printCount);
    const filename = generateUniqueFilename('Invoice', 'pdf');

    doc.autoPrint();
    window.open(doc.output('bloburl'));

  } catch (error) {
    console.error('Error generating PDF:', error);
  }
};

export default generateSummaryPDF;